import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "document-browser-tab-container kn-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fa fa-folder-open" }, null, -1)
const _hoisted_4 = {
  key: 0,
  id: "document-browser-tab-icon-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentBrowserHome = _resolveComponent("DocumentBrowserHome")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DocumentBrowserTab = _resolveComponent("DocumentBrowserTab")
  const _component_Menu = _resolveComponent("Menu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, {
        id: "document-browser-tab-view",
        class: "p-d-flex p-flex-column kn-flex kn-tab",
        activeIndex: _ctx.activeIndex,
        "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeIndex = $event)),
        onTabChange: _ctx.onTabChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DocumentBrowserHome, {
                documentSaved: _ctx.documentSaved,
                documentSavedTrigger: _ctx.documentSavedTrigger,
                onItemSelected: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onItemSelect($event)))
              }, null, 8, ["documentSaved", "documentSavedTrigger"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
            return (_openBlock(), _createBlock(_component_TabPanel, { key: index }, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.getTabName(tab)), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeIndex", "onTabChange"]),
      _withDirectives(_createVNode(_component_DocumentBrowserTab, {
        item: _ctx.selectedItem?.item,
        functionalityId: _ctx.selectedItem?.functionalityId,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDocument('current'))),
        onIframeCreated: _ctx.onIFrameCreated,
        onCloseIframe: _ctx.closeIframe,
        onDocumentSaved: _ctx.onDocumentSaved
      }, null, 8, ["item", "functionalityId", "onIframeCreated", "onCloseIframe", "onDocumentSaved"]), [
        [_vShow, _ctx.selectedItem && _ctx.selectedItem.mode]
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.iFrameContainers, (iframe, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _withDirectives(_createVNode("iframe", {
            ref: "iframe",
            class: "document-browser-cockpit-iframe",
            src: iframe.iframe
          }, null, 8, ["src"]), [
            [_vShow, iframe.item?.routerId === _ctx.selectedItem?.item.routerId]
          ])
        ]))
      }), 128)),
      (_ctx.activeIndex !== 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("i", {
              id: "document-browser-tab-icon",
              class: "fa fa-times-circle",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggle($event)))
            }),
            _createVNode(_component_Menu, {
              ref: "menu",
              model: _ctx.menuItems,
              popup: true
            }, null, 8, ["model"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}